import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'filterWithCallback'
})

export class FilterWithCallbackPipe implements PipeTransform {

	transform(items: any[], callback: (itemToFilter: any, searchFilters: any) => boolean, filters: any): any {
	    if (!items || !callback) {
	        return items;
	    }
	    return items.filter((item) => callback(item, filters));
	}
   
}